module.exports = AutoIncrementer;

function AutoIncrementer(startValue, maxValue) {
    this._startValue = startValue;
    this._maxValue = maxValue;

    this.reset();
}

AutoIncrementer.prototype = {
    reset: function() {
        this._currentValue = this._startValue;
    },
    get: function() {
        let tmpValue = this._currentValue;

        if (this._currentValue >= this._maxValue)
            this.reset();
        else
            this._currentValue++;
        
        return tmpValue;
    }
}